import { Reveal, Overline } from "./Reveal";

const STEPS = [
  { n: "01", t: "Diagnóstico", d: "Entendemos o caso, a atividade e o objetivo — no campo e na conversa." },
  { n: "02", t: "Documentação", d: "Levantamento de CAR, CCIR, ITR e matrícula, com conferência dos cadastros." },
  { n: "03", t: "Projeto", d: "Elaboração do projeto técnico, do laudo ou do parecer, com orçamento." },
  { n: "04", t: "Vistoria", d: "Verificação in loco com registro fotográfico, medições e evidências." },
  { n: "05", t: "Entrega e protocolo", d: "Entrega do projeto, laudo ou parecer e apoio no protocolo junto ao banco, à seguradora, ao cartório ou ao juízo." },
  { n: "06", t: "Suporte pós-entrega", d: "Esclarecimentos e complementações após a entrega, quando o banco, a seguradora, o cartório ou o juízo solicitar." },
];


export const Process = () => (
  <section id="metodo" data-testid="process-section" className="grain relative bg-[#1B2F1D] py-10 text-[#F9F8F3] sm:py-14 md:py-36">
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-start">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal><Overline light>Como trabalhamos</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight sm:mt-8 sm:text-5xl lg:text-6xl">
                Seis etapas, uma regra: <em className="text-[#8FC690]">nada sem evidência.</em>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p data-testid="process-highlight" className="mt-6 max-w-md rounded-[20px] border border-[#8FC690]/30 bg-[#8FC690]/10 p-5 text-base font-medium leading-relaxed text-[#F9F8F3] sm:mt-8 sm:p-6 sm:text-lg">
                Nenhuma conclusão sem documento, vistoria ou evidência rastreável.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 sm:gap-5">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={0.05 * i}>
                <div data-testid={`process-step-${s.n}`} className="h-full rounded-[20px] border border-white/10 bg-white/5 p-4 sm:p-6">
                  <span className="font-mono text-xs tracking-[0.15em] text-[#8FC690]">{s.n}</span>
                  <h3 className="mt-2 font-serif text-xl leading-tight sm:mt-3 sm:text-2xl">{s.t}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-[#F9F8F3]/75 sm:mt-2">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
